import React, { CSSProperties, FC } from 'react'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKButton from 'shared/LKButton'
import styled from 'styled-components'
import LKModal, { LKModalTrigger } from '../../shared/LKModal'
import LKGrid from '../../shared/LKGrid'
import FormField from '../../shared/newFormElements'
import containers from './containers'
import DeleteConfirmationTrigger from './DeleteConfirmationTrigger'

import { CommentsListItem, CommentsModalProps } from './CommentsModa.types'
import { RowNode } from 'ag-grid'

const CommentInputsWrapper = styled.div`
  display: flex;
  margin-top: 10px;

  .comment__input {
    margin-right: 5px;
  }

  .comment__actions {
    display: flex;
    justify-content: space-between;
  }
`

const LKGridConfig = {
  instanceName: 'OrderAddComments',

  gridIdentity: {
    formName: 'frm_acc_entry_comments',
    objectName: 'dbgrd_entry_comments',
  },

  columnDefs: [{ headerName: 'Title', field: 'Title' }],

  enableColumnsResize: true,
  getRowNodeId: (row) => row?.ID,
  enableRowSelection: true,
}
//@ts-ignore
@containers
class CommentsModal extends React.Component<CommentsModalProps> {
  componentWillUnmount() {
    this.props.destroyGrid('OrderAddComments')
    // this.props.destroyFetcher('OrderCommentsList')
    this.props.destroyComments()
    this.props.destroyFetcher('AddEditOrderComment')
  }

  onGridReady = ({ api }) => {
    api.forEachNode((node: RowNode, index: number) => {
      if (index === 0) {
        node.setSelected(true, true)
      }
    })

    api.sizeColumnsToFit()
  }

  onRowDoubleClicked = ({ data }: { data: CommentsListItem }) => {
    this.props.closeModal()
    this.props.onRowChoose(data)
  }

  onChoose = () => {
    this.props.closeModal()
    if (this.props.selected) {
      this.props.onRowChoose(this.props.selected)
    }
  }

  onRowSelected = ({ data, node: { selected } }: { data: CommentsListItem; node: { selected: boolean } }) => {
    if (selected) {
      this.props.change('Comment', data.Title)
    }
  }

  handleCheckboxCheck = (checked: boolean) => {
    this.props.fetchComments(checked)
  }

  addComment = () => {
    this.props.change('action', 'add')
    setTimeout(this.props.submit, 0)
  }

  editComment = () => {
    this.props.change('action', 'edit')
    setTimeout(this.props.submit, 0)
  }

  deleteComment = () => {
    this.props.change('action', 'delete')
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { modalInstanceName, list, submitting, loading } = this.props
    return (
      //@ts-ignore
      <LKModal
        name={modalInstanceName}
        heading={translate('frm_acc_entry_comments-frm_acc_entry_comments')}
        loading={loading}
        size="sm-1"
        footer={
          //@ts-ignore
          <LKModal.Footer
            actions={
              //@ts-ignore
              <FormField
                type="checkbox"
                name="operationFilter"
                customOnChange={this.handleCheckboxCheck}
                label={translate('frm_acc_entry_comments-chk_all_opertype')}
              />
            }
            sideActions={
              <LKButton alias="ok" onClick={this.onChoose}>
                {translate('frm_acc_entry_comments-cmd_select')}
              </LKButton>
            }
          />
        }
      >
        <LKGrid
          rowData={list ? list.Data : undefined}
          {...LKGridConfig}
          onGridReady={this.onGridReady}
          onRowDoubleClicked={this.onRowDoubleClicked}
          onRowSelected={this.onRowSelected}
        />

        <CommentInputsWrapper>
          {/* @ts-ignore */}
          <FormField
            className="comment__input"
            name="Comment"
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.keyCode === 13) this.addComment()
            }}
          />

          <div className="comment__actions">
            <LKButton disabled={submitting} alias="add" onClick={this.addComment} />
            <LKButton disabled={submitting} alias="edit" onClick={this.editComment} />
            <DeleteConfirmationTrigger alias="delete" disabled={submitting} onConfirm={this.deleteComment} />
          </div>
        </CommentInputsWrapper>
      </LKModal>
    )
  }
}

const CommentsModalTrigger: FC<{
  onRowChoose: (data: any) => void
  disabled: boolean
  style?: CSSProperties
  OperTypeID: number
}> = ({ onRowChoose, disabled, style, OperTypeID }) => (
  <>
    {/* @ts-ignore */}
    <LKModalTrigger disabled={disabled} name="OrderComments" alias="add" style={style} />
    {/* @ts-ignore */}
    <CommentsModal onRowChoose={onRowChoose} OperTypeID={OperTypeID} />
  </>
)

export default CommentsModalTrigger
